import type * as React from "react";

import { Chip, type ChipProps, type ChipTone } from "./Chip";
import {
  FileTextIcon,
  FlaskIcon,
  MessageIcon,
  PinIcon,
  ReceiptIcon,
} from "./Icons";

/** `draft`: a visit whose note awaits the DVM. */
export type HistoryItemKind =
  | "invoice"
  | "visit"
  | "draft"
  | "document"
  | "lab"
  | "message";

const kindChip: Record<
  HistoryItemKind,
  { tone: ChipTone; Icon: React.ComponentType }
> = {
  invoice: { tone: "recorded", Icon: ReceiptIcon },
  visit: { tone: "brian", Icon: PinIcon },
  draft: { tone: "attention", Icon: FileTextIcon },
  document: { tone: "brian", Icon: FileTextIcon },
  lab: { tone: "attention", Icon: FlaskIcon },
  message: { tone: "brian", Icon: MessageIcon },
};

export interface TypeChipProps extends Omit<ChipProps, "tone" | "icon"> {
  kind: HistoryItemKind;
}

export function TypeChip({ kind, size = "sm", ...rest }: TypeChipProps) {
  const { tone, Icon } = kindChip[kind];
  return <Chip tone={tone} size={size} icon={<Icon />} {...rest} />;
}
